/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

export type FeatureFlagChangeOperation =
  (typeof FeatureFlagChangeOperation)[keyof typeof FeatureFlagChangeOperation]

export const FeatureFlagChangeOperation = {
  INSERT: "INSERT",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
} as const
